import { render, staticRenderFns } from "./quotaCache.vue?vue&type=template&id=3cfafefe&scoped=true&"
import script from "./quotaCache.vue?vue&type=script&lang=js&"
export * from "./quotaCache.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfafefe",
  null
  
)

export default component.exports